<template>
	<div class="full flex" style="flex-direction: column;">
		<div style="padding: 10px;">
			<el-radio-group v-model="type" @input="input">
				<el-radio label="source">蓝票</el-radio>
				<el-radio v-for="(item,index) in relationinvoice" :key="index" :label="index" >{{'红票'+(index+1)}}</el-radio>
			</el-radio-group>
		</div>
		<iframe class="full" scrolling="yes" style="position: relative;padding: 0;margin: 0;border: none;flex: 1;" v-if="invoiceurl"
			:src="invoiceurl"></iframe>
	</div>
</template>
<style scoped>

</style>
<script>
	export default {
		props: {
			invoicedata: {
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				invoiceurl: null,
				type:'source',
				relationinvoice:[]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			this.getrelationinvoice()
			this.getinputinvoicepdf()
		},
		methods: {
			input(e){
				if(e!='source'){
					this.getinputinvoicepdf(this.relationinvoice[e])
				}else{
					this.getinputinvoicepdf()
				}			
			},
			getrelationinvoice(){		
				let row = this.invoicedata
				this.$api.invoice.getrelationinvoice({
					invoiceNumber: row.invoiceNumber,
					invoiceType: row.invoiceType
				}).then((res) => {
					let relationinvoice = []
					res.forEach((item)=>{
						relationinvoice.push(item)
					})
					this.relationinvoice = relationinvoice
					//console.log(res)
				}, () => {
				
				})
			},
			getinputinvoicepdf(data = null) {
				let row = this.invoicedata
				if(data){
					row = data
				}
				//console.log(row,123123)
				this.$api.invoice.getinputinvoicepdf({
					customerId: row.customerId,
					downFileType: 'PDF',
					invoiceId: row.invoiceId,
					invoiceType: row.invoiceType
				}).then((res) => {
					const base64Data = res.replace(/^data:application\/pdf;base64,/, '');
					const binaryString = atob(base64Data);
					const bytes = new Uint8Array(binaryString.length);
					for (let i = 0; i < binaryString.length; i++) {
						bytes[i] = binaryString.charCodeAt(i);
					}
					const blob = new Blob([bytes], {
						type: 'application/pdf'
					});
					const url = URL.createObjectURL(blob);
					this.invoiceurl = url
					console.log(url, 123123123)
					//window.open(url, '_blank');
				}, () => {

				})
			}
		},
		components: {

		}
	}
</script>